// Relative label within a week ("3 days ago"), else absolute date; UTC-pinned.
// nowMs null (SSR/pre-mount) forces the absolute date to avoid a hydration mismatch.

function ago(value: number, unit: string) {
  return `${value} ${unit}${value === 1 ? '' : 's'} ago`
}

export function trustpilotReviewDate(iso: string, nowMs: number | null, currentYear: number): string {
  const d = new Date(iso)
  if (Number.isNaN(d.getTime()))
    return ''

  if (nowMs != null) {
    const sec = Math.floor((nowMs - d.getTime()) / 1000)
    if (sec < 1)
      return 'just now'
    if (sec < 60)
      return ago(sec, 'second')
    const min = Math.floor(sec / 60)
    if (min < 60)
      return ago(min, 'minute')
    const hr = Math.floor(min / 60)
    if (hr < 24)
      return ago(hr, 'hour')
    const day = Math.floor(hr / 24)
    if (day < 7)
      return ago(day, 'day')
  }

  const opts: Intl.DateTimeFormatOptions = d.getUTCFullYear() === currentYear
    ? { month: 'long', day: 'numeric', timeZone: 'UTC' }
    : { month: 'long', day: 'numeric', year: 'numeric', timeZone: 'UTC' }
  return d.toLocaleDateString('en-US', opts)
}
